/**
 * @generated SignedSource<<ef48d192981f0f268b9ad7c92dd887db>>
 * @relayHash c8e36dd3f69248a71385ba85e14baf53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 11a4a1773edd0bed1ab5a91c27491612d6e74bcc2831efc2008ec42047a543f2

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateNumberFieldInput = {
  id: string;
  operation: JiraNumberFieldOperationInput;
};
export type JiraNumberFieldOperationInput = {
  number?: number | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type number_issueFieldNumber_NumberFieldOld_Mutation$variables = {
  input: JiraUpdateNumberFieldInput;
};
export type number_issueFieldNumber_NumberFieldOld_Mutation$data = {
  readonly jira: {
    readonly updateNumberField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly number: number | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type number_issueFieldNumber_NumberFieldOld_Mutation$rawResponse = {
  readonly jira: {
    readonly updateNumberField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly number: number | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type number_issueFieldNumber_NumberFieldOld_Mutation = {
  rawResponse: number_issueFieldNumber_NumberFieldOld_Mutation$rawResponse;
  response: number_issueFieldNumber_NumberFieldOld_Mutation$data;
  variables: number_issueFieldNumber_NumberFieldOld_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "concreteType": "JiraMutation",
    "kind": "LinkedField",
    "name": "jira",
    "plural": false,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
          }
        ],
        "concreteType": "JiraNumberFieldPayload",
        "kind": "LinkedField",
        "name": "updateNumberField",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "success"
          },
          {
            "concreteType": "MutationError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "message"
              }
            ]
          },
          {
            "concreteType": "JiraNumberField",
            "kind": "LinkedField",
            "name": "field",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "id"
              },
              {
                "kind": "ScalarField",
                "name": "number"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "number_issueFieldNumber_NumberFieldOld_Mutation",
    "selections": (v1/*: any*/),
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "number_issueFieldNumber_NumberFieldOld_Mutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "11a4a1773edd0bed1ab5a91c27491612d6e74bcc2831efc2008ec42047a543f2",
    "metadata": {},
    "name": "number_issueFieldNumber_NumberFieldOld_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "ac912bce87973eb366494b28c4298c64";

export default node;
